var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 119,
    height: 84.337,
    viewBox: "0 0 119 84.337",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Path_180-2",
    x: 14.989,
    y: 0,
    width: 77.074,
    height: 67.592,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.243
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3930",
    "data-name": "Group 3930",
    transform: "translate(7619 -4000.663)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3924",
    "data-name": "Group 3924",
    transform: "translate(25.981 -81.891)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -7644.98, 4082.55)",
    filter: "url(#Path_180-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_180-2-2",
    "data-name": "Path 180-2",
    d: "M3766.97-863.737a2.551,2.551,0,0,0-1.489-2.108c-.915-.5-1.669-1.258-2.556-1.836a12.653,12.653,0,0,0-7.744-2.123,19.312,19.312,0,0,0-4.074.589c-.566.15-1,.139-.825-.667.055-.252-.029-.533.015-.79a2.316,2.316,0,0,0-1.01-2.5c-.31-.218-.68-.569-.466-1.043.206-.454.661-.252,1.017-.258,4.843-.083,9.685-.175,14.529-.217a13.135,13.135,0,0,1,2.893.166,1.675,1.675,0,0,1,1.361,1.028,3.123,3.123,0,0,0,2.818,1.991c4.134.4,8.283.395,12.422.623,1.966.109,3.936.129,5.9.179.5.013.832.126.81.738-.014.411,1.133,1.189,1.55,1.118.288-.049.24-.306.281-.479a4.776,4.776,0,0,0,.061-2.941c-.3-.77.019-.92.729-.76.887.2,1.784.365,2.681.511a.754.754,0,0,1,.694.753,44.382,44.382,0,0,0,4.511,12.918,17.633,17.633,0,0,0,2.4,3.366,7.34,7.34,0,0,1,1.142,1.447c.207.435.311.8-.152,1.148a.934.934,0,0,0-.258,1.175,16.985,16.985,0,0,0,1.745,4.167c.961,1.5,1.367,3.365,2.247,4.959a15.1,15.1,0,0,1,1.517,8.962,13.61,13.61,0,0,0-.085,3.248,1.076,1.076,0,0,1-.892,1.374c-.169.03-.413.137-.361.321.231.819-.369,1.5-.306,2.311a2.268,2.268,0,0,1-2.588,2.486,2.324,2.324,0,0,0-1.937.475c-.688.61-1.327.21-1.354-.724a6.5,6.5,0,0,0-2.6-5.32,3.23,3.23,0,0,0-1.563-.5c-1.13-.189-1.64-.631-1.692-1.777a7.252,7.252,0,0,0-.906-2.64,2.369,2.369,0,0,0-.956-.888c-.417-.293-.548.16-.753.352-.356.333-.53.347-.727-.174a28.827,28.827,0,0,0-4.23-8.052c-.243-.3-.284-.51.046-.8a13.79,13.79,0,0,0,1.805-2.272.966.966,0,0,0-.548-1.651c-.711-.237-1.4-.665-2.2-.285-.351.168-.376-.089-.415-.336a3.038,3.038,0,0,1,.227-1.973c.859-1.623.639-3.44.916-5.168.042-.263-.135-.439-.264-.63a6.592,6.592,0,0,1-1.2-2.332.744.744,0,0,0-.59-.581c-.448-.138-.885-.315-1.325-.478-.193-.071-.468-.093-.561-.233-.744-1.128-2.255-1.621-2.573-3.085a.97.97,0,0,0-.623-.774,1.437,1.437,0,0,1-.813-.63c-.339-.625-.551-1.278-1.337-1.644-1.618-.753-3.113-1.718-5.06-1.258-.815.193-.625.734-.688,1.189-.041.3-.016.516-.395.4a1.16,1.16,0,0,0-1.181.393,4.359,4.359,0,0,1-3.984,1.385A3.115,3.115,0,0,0,3766.97-863.737Z",
    transform: "translate(-3725.76 882.69)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFl);
export default __webpack_public_path__ + "static/media/FL.f68de86867981ccc6c96e025ba10331d.svg";
export { ForwardRef as ReactComponent };